import { mapBoundsReducer } from "./index";
import { useCallback, useReducer } from "react";
import { MapBoundsChangedListener } from "../types";

export const useGetDistanceFromBottom = () => {
  const [mapBoundsPayload, dispatchMapBoundsPayload] = useReducer(
    mapBoundsReducer,
    {}
  );

  const handleMapBoundsChanged: MapBoundsChangedListener = useCallback(
    (payload) => {
      const { zoom, southWest, projection } = payload;
      if (!southWest || !zoom || !projection) {
        return;
      }

      dispatchMapBoundsPayload({
        type: "MAP_BOUNDS_CHANGED",
        payload: {
          ...payload,
          southWest: new google.maps.LatLng(southWest.toJSON()),
        },
      });
    },
    []
  );

  const getDistanceFromBottom = useCallback(
    (markerLatLng: google.maps.LatLng) => {
      const { projection, zoom, southWest } = mapBoundsPayload;
      if (!projection) {
        return undefined;
      }

      if (!zoom) {
        return undefined;
      }

      if (!southWest) {
        return undefined;
      }

      var bottomLeft = projection.fromLatLngToPoint(southWest);
      if (!bottomLeft) {
        return undefined;
      }

      var scale = Math.pow(2, zoom);
      var worldPoint = projection.fromLatLngToPoint(markerLatLng);
      if (!worldPoint) {
        return undefined;
      }

      return Math.floor((bottomLeft.y - worldPoint.y) * scale);
    },
    [mapBoundsPayload]
  );

  return {
    handleMapBoundsChanged,
    getDistanceFromBottom,
  };
};
